export default __webpack_public_path__ + "static/media/ico_icu_disabled.376bcf66.svg";